import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopNEmployers = async (urlDataAPI: any) => {
    const { exportType, hubIds, sectorIds, occupationCategoryIds, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportTopNEmployers;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, ISICCodes: sectorIds, ISCO2Codes: occupationCategoryIds, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};